/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CertifiedPartner.vue?vue&type=template&id=756a976b"
import script from "./CertifiedPartner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertifiedPartner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CertifiedPartner.vue?vue&type=style&index=0&id=756a976b&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports